import actionTypes from '../constants/action-types';
import SharedApi from '../../../../api/shared-api';
import { handleHttpInProgress } from '../../../shared/http-in-progress/actions/http-in-progress-actions';

export const getSites = (active, pageCode) => {
  return async dispatch => {
    dispatch(handleHttpInProgress(true));
    try {
      const response = await SharedApi.getSites(active, pageCode);
      const sites = response && response.data;
      dispatch(handleSuccessGetSites(sites));
      dispatch(handleHttpInProgress(false));
    } catch (error) {
      dispatch(handleHttpInProgress(false));
    }
  };
};

export const setCampaign = campaign => {
  return {
    type: actionTypes.HANDLE_SET_LINK_CREATOR_CAMPAIGN,
    data: campaign,
  };
};

export const setLanguage = lang => {
  return {
    type: actionTypes.HANDLE_SET_LINK_CREATOR_LANGUAGE,
    data: lang,
  };
};

export const setAnchor = text => {
  return {
    type: actionTypes.HANDLE_ANCHOR_TEXT_CHANGE,
    data: text,
  };
};

export const handleSuccessGetSites = sites => {
  return {
    type: actionTypes.HANDLE_SUCCESS_GET_SITES,
    data: sites,
  };
};



// WEBPACK FOOTER //
// ./src/app/main/link-creator/actions/link-creator-actions.js